import { env } from 'utils';

const SNAPS_DOMAIN = process.env.NEXT_PUBLIC_SNAPS_CLIENT;

const seo = {
	type: 'website',
	locale: 'en_US',
	favicon: `/favicon.png`,
	photo: `${SNAPS_DOMAIN}/api/image?container=app&url=www.playbooks.ai&format=png`,
	title: 'Playbooks',
	description: `Playbooks is an AI-native platform that helps entrepreneurs, business owners, and operators transform ideas into intelligent products.`,
	keywords: `hybrid source software, developer economy, indie developers, software templates, software partials, software starters, software themes, software apps`,
	card: 'summary',
	siteName: 'Playbooks',
	site: '@playbooks_hq',
	baseUrl: process.env.NEXT_PUBLIC_WEB_CLIENT,
	robots: env === 'production',
};

export { seo };
